import React, { useEffect, useState } from 'react';
import { RootState, useSelector } from '../../redux/store';
import useLocales from '../../hooks/useLocales';
import getBusinessTypeName from '../../utils/getBusinessTypeName';
import type { ICellRendererParams } from 'ag-grid-community';

const BusinessTypeCellRenderer = (params: ICellRendererParams): React.ReactElement => {
  const businessTypeCodes: string[] = Array.isArray(params.value) ? params.value : [params.value];
  // console.log(steelMakerCodes);
  const { currentLang } = useLocales();
  const { businessType } = useSelector((state: RootState) => state.options);
  const [displayName, setDisplayName] = useState<string>('');

  // SIDE EFFECT
  // ================================================================================

  useEffect(() => {
    // 区分の配列を区分名の配列にマップする。マッチするものが見つからなかったらコードのままにする。
    const mappedCodes: string[] = businessTypeCodes.map((code) => {
      const businessTypeName: string = getBusinessTypeName(code, businessType, currentLang.value);
      return businessTypeName;
    });
    setDisplayName(mappedCodes.join(', '));
  }, [businessType, currentLang]);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return <span className="business-type-name">{displayName}</span>;
};

export default BusinessTypeCellRenderer;
